export class ProductsClassesGroup {
    constructor({
                    //attributes
                    id = null,
                    company_id = null,
                    name = '',
                    default_total_formula_id = null,
                    formula_conditions = [],
                    calculation_order = [],
                    settings = {},
                    //relations
                    classes = []
                } = {}) {
        if(settings == null)
            settings = {calc_type: 'calc_only'};

        //fill attributes
        this.id = id;
        this.company_id = company_id;
        this.name = name;
        this.default_total_formula_id = default_total_formula_id;
        this.formula_conditions = formula_conditions;
        this.calculation_order = calculation_order
        this.settings = settings;
        
        //fill relations
        this.classes = classes;
    }

}

export function createProductsClassesGroup(data={}) {
    return Object.freeze(new ProductsClassesGroup(data));
}
